import "./hero.css";

import React from "react";
import { Button } from "@mui/material";

import { HERO } from "../../data/content";
import { SECTIONS } from "../../utils/stateTypes";
import { SectionLink } from "../layout/TopNav";
import Reveal from "../general/Reveal";

/* The geometric tile artwork from the original site, layer for layer. Sizes are the original's pixels in its 511 x 516 box
*  (converted to % so the art scales). Hovering the art plays the original's animation: the top-left leaf layers fan out to
*  the right, the circle layers fan out to the left and the two bottom strips fade away (see hero.css). */
const ART_W = 511;
const ART_H = 516;
const TILES = [
  //Top row
  { x: 0, y: 0, w: 230, h: 172, kind: "grey", shape: "leaf" },
  { x: 0, y: 0, w: 230, h: 172, kind: "lavender", shape: "leaf", hover: "fan-r1" },
  { x: 0, y: 0, w: 230, h: 172, kind: "stone", shape: "leaf", hover: "fan-r2" },
  { x: 230, y: 0, w: 281, h: 172, kind: "lavender", shape: "curve-bl", hover: "fan-r2" },
  //Middle row
  { x: 0, y: 172, w: 332, h: 172, kind: "blue", shape: "pill-r" },
  { x: 332, y: 172, w: 179, h: 172, kind: "lavender", shape: "circle" },
  { x: 332, y: 172, w: 179, h: 172, kind: "grey", shape: "circle", hover: "fan-l1" },
  { x: 332, y: 172, w: 179, h: 172, kind: "stone", shape: "circle", hover: "fan-l2" },
  //Bottom row
  { x: 0, y: 344, w: 179, h: 172, kind: "stone", shape: "curve-bl" },
  { x: 178, y: 344, w: 333, h: 172, kind: "lavender", shape: "pill-r" },
  { x: 178, y: 344, w: 66, h: 172, kind: "white", hover: "fade-1" },
  { x: 244, y: 344, w: 66, h: 172, kind: "blue", hover: "fade-2" },
];

const pct = (val, total) => `${(val / total) * 100}%`;

export const TileArt = ({ className = "" }) => (
  <div
    className={`tile-art ${className}`}
    aria-hidden={"true"}
  >
    {TILES.map((tile, i) => (
      <span
        key={i}
        className={["tile", `tile-${tile.kind}`, tile.shape ? `tile-${tile.shape}` : "", tile.hover ? `tile-${tile.hover}` : ""].join(" ")}
        style={{
          left: pct(tile.x, ART_W),
          top: pct(tile.y, ART_H),
          width: pct(tile.w, ART_W),
          height: pct(tile.h, ART_H),
        }}
      />
    ))}
  </div>
);

const Hero = () => {
  return (
    <section className={"hero"}>
      <div className={"container hero-grid"}>
        {/* The whole text block slides in from the left as the page opens, like the original */}
        <Reveal
          className={"hero-text"}
          variant={"slide"}
          delay={0.2}
        >
          <h1 className={"hero-title"}>
            {HERO.titleLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h1>
          <p className={"hero-lead"}>{HERO.lead}</p>
          <Button
            component={SectionLink}
            section={SECTIONS.CONTACT}
            variant={"contained"}
            size={"large"}
          >
            Contact Us
          </Button>
        </Reveal>
        <TileArt className={"hero-art"} />
      </div>
    </section>
  );
};

export default Hero;
